import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class LiveHubResponse extends Array {
    public LastSort = new SortItem;
}
